<template>
  <main-template hide-franquia>
    <v-row class="mx-2">
      <v-col cols="12">
        <v-card class="elevation-2 rounded-xl overflow-hidden mt-4">
          <v-card-title
            class="headline py-4 px-6 border-bottom d-flex align-center justify-space-between flex-wrap"
          >
            <div class="d-flex align-center">
              <v-btn
                color="primary"
                x-small
                text
                @click="() => $router.push({ name: 'acessoResponsavel.home' })"
                :disabled="false"
              >
                <v-icon left> fa fa-angle-left </v-icon>
              </v-btn>
              <div>
                <div class="font-weight-bold text-h6 primary--text">Presenças do Aluno</div>
                <div class="text-caption grey--text">Histórico de registros Notifiq</div>
              </div>
            </div>
          </v-card-title>

          <v-card-text class="pt-6 px-6">
            <v-row class="mb-6">
              <v-col cols="12" sm="4" class="py-2">
                <v-card flat class="blue lighten-5 text-center py-4 rounded-xl border">
                  <v-icon color="blue" size="32" class="mb-2">mdi-chart-list</v-icon>
                  <div
                    class="text-caption text-uppercase font-weight-bold grey--text text--darken-1"
                  >
                    Total Registros
                  </div>
                  <div class="text-h4 font-weight-black blue--text mt-1">
                    {{ presencas.length }}
                  </div>
                </v-card>
              </v-col>
              <v-col cols="12" sm="4" class="py-2">
                <v-card flat class="green lighten-5 text-center py-4 rounded-xl border">
                  <v-icon color="green" size="32" class="mb-2">mdi-login</v-icon>
                  <div
                    class="text-caption text-uppercase font-weight-bold grey--text text--darken-1"
                  >
                    Entradas
                  </div>
                  <div class="text-h4 font-weight-black green--text mt-1">{{ totalEntradas }}</div>
                </v-card>
              </v-col>
              <v-col cols="12" sm="4" class="py-2">
                <v-card flat class="orange lighten-5 text-center py-4 rounded-xl border">
                  <v-icon color="orange" size="32" class="mb-2">mdi-logout</v-icon>
                  <div
                    class="text-caption text-uppercase font-weight-bold grey--text text--darken-1"
                  >
                    Saídas
                  </div>
                  <div class="text-h4 font-weight-black orange--text mt-1">{{ totalSaidas }}</div>
                </v-card>
              </v-col>
            </v-row>

            <v-row class="mb-6 align-center">
              <v-col cols="12" sm="5" md="4" class="py-1">
                <v-btn
                  color="primary"
                  outlined
                  height="40"
                  class="date-picker-btn"
                  @click="abrirDatePicker"
                >
                  <v-icon left small>mdi-calendar</v-icon>
                  {{ dataLabel }}
                </v-btn>
              </v-col>
              <v-col cols="12" sm="5" md="4" class="py-1">
                <v-select
                  v-model="filtroEvento"
                  :items="eventos"
                  label="Tipo de Registro"
                  item-text="text"
                  item-value="value"
                  dense
                  outlined
                  hide-details
                  prepend-inner-icon="mdi-filter-variant"
                  clearable
                />
              </v-col>
              <v-col cols="12" sm="2" md="4" class="py-1 d-flex align-center">
                <v-btn color="primary" class="px-6 rounded-lg" @click="buscarPresencas">
                  <v-icon left>mdi-magnify</v-icon>
                  Buscar
                </v-btn>
              </v-col>
            </v-row>

            <v-divider class="my-6"></v-divider>

            <v-data-table
              :headers="headers"
              :items="presencas"
              :loading="carregando"
              :items-per-page="itensPorPagina"
              :page.sync="paginaAtual"
              hide-default-footer
              no-data-text="Nenhuma presença registrada para os filtros selecionados."
              loading-text="Carregando presenças do Notifiq..."
              class="elevation-0 border rounded-lg"
            >
              <template v-slot:item.data_evento="{ item }">
                <div class="d-flex align-center">
                  <v-icon small class="mr-2 grey--text">mdi-calendar-range</v-icon>
                  <span>{{ formatDate(item.data_evento) }}</span>
                </div>
              </template>

              <template v-slot:item.hora_evento="{ item }">
                <div class="d-flex align-center">
                  <v-icon small class="mr-2 grey--text">mdi-clock-outline</v-icon>
                  <span>{{ formatTime(item.data_evento) }}</span>
                </div>
              </template>

              <template v-slot:item.evento="{ item }">
                <v-chip
                  small
                  :color="
                    item.evento === 0
                      ? 'green lighten-4 green--text'
                      : 'orange lighten-4 orange--text'
                  "
                  class="font-weight-bold"
                  label
                >
                  <v-icon small left :color="item.evento === 0 ? 'green' : 'orange'">
                    {{ item.evento === 0 ? "mdi-login" : "mdi-logout" }}
                  </v-icon>
                  {{ item.evento === 0 ? "Entrada" : "Saída" }}
                </v-chip>
              </template>
            </v-data-table>

            <div class="pt-6 d-flex justify-center">
              <e-paginate
                v-if="totalPaginas > 1"
                :key="totalPaginas + '-' + paginaAtual"
                :current_page="paginaAtual"
                :last_page="totalPaginas"
                :pageNumber="paginaAtual - 1"
                @changeActionResponse="mudarPagina"
                :search="''"
              ></e-paginate>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Dialog Date Picker -->
    <v-dialog v-model="dialogData" max-width="350">
      <v-card class="rounded-xl overflow-hidden">
        <v-card-title class="text-h6 font-weight-bold grey lighten-5 py-3 px-4 border-bottom">
          Selecionar data
        </v-card-title>
        <v-card-text class="pt-4 d-flex justify-center">
          <v-date-picker v-model="dataSelecionada" locale="pt-br" color="primary"></v-date-picker>
        </v-card-text>
        <v-card-actions class="grey lighten-5 py-3 px-4 d-flex justify-end border-top">
          <v-btn color="grey" text @click="dialogData = false">Cancelar</v-btn>
          <v-btn color="grey darken-3" text @click="limparData">Limpar</v-btn>
          <v-btn color="success" text @click="aplicarData">Aplicar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </main-template>
</template>

<script>
export default {
  props: {
    matricula_id: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      presencas: [],
      filtroData: null,
      filtroEvento: null,
      dialogData: false,
      dataSelecionada: null,
      carregando: false,
      paginaAtual: 1,
      itensPorPagina: 10,
      eventos: [
        { text: "Entrada", value: 0 },
        { text: "Saída", value: 1 },
      ],
      headers: [
        { text: "ID", value: "id", sortable: true, width: "10%" },
        { text: "Data", value: "data_evento", sortable: true, width: "35%" },
        { text: "Hora", value: "hora_evento", sortable: false, width: "35%" },
        { text: "Tipo de Registro", value: "evento", sortable: true, width: "20%" },
      ],
    };
  },
  computed: {
    totalEntradas() {
      return this.presencas.filter((presenca) => presenca.evento === 0).length;
    },
    totalSaidas() {
      return this.presencas.filter((presenca) => presenca.evento === 1).length;
    },
    totalPaginas() {
      return Math.ceil(this.presencas.length / this.itensPorPagina) || 1;
    },
    dataLabel() {
      if (!this.filtroData) return "Selecionar data";
      return this.formatarDataFiltro(this.filtroData);
    },
  },
  mounted() {
    this.buscarPresencas();
  },
  methods: {
    async buscarPresencas() {
      try {
        this.carregando = true;
        const params = { matricula_id: this.matricula_id };
        if (this.filtroData) params.data = this.filtroData;
        if (this.filtroEvento !== null) params.evento = this.filtroEvento;

        const response = await this.$services.presencasService.getPresencasHikvision(params);
        this.presencas = (response.presencas || []).sort((a, b) => {
          const dataA = new Date(a.data_evento).getTime();
          const dataB = new Date(b.data_evento).getTime();
          return dataB - dataA;
        });
        this.paginaAtual = 1;
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.carregando = false;
      }
    },
    mudarPagina(page) {
      this.paginaAtual = page;
    },
    abrirDatePicker() {
      this.dataSelecionada = this.filtroData || new Date().toISOString().substr(0, 10);
      this.dialogData = true;
    },
    aplicarData() {
      this.filtroData = this.dataSelecionada;
      this.dialogData = false;
    },
    limparData() {
      this.filtroData = null;
      this.dataSelecionada = null;
      this.dialogData = false;
    },
    formatarDataFiltro(data) {
      if (!data) return "";
      const [ano, mes, dia] = data.split("-");
      return `${dia}/${mes}/${ano}`;
    },
    formatDate(value) {
      if (!value) return "- - -";

      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return "- - -";

      return date.toLocaleDateString("pt-BR");
    },
    formatTime(value) {
      if (!value) return "- - -";

      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return "- - -";

      return date.toLocaleTimeString("pt-BR");
    },
  },
};
</script>

<style scoped>
.date-picker-btn {
  justify-content: flex-start;
  width: 100%;
}
</style>
